module.exports = __webpack_public_path__ + "img/st-cb6-1-001.4cdd81e3.gif";